module.exports = __webpack_public_path__ + "img/ersonal_resources_menu_open.2749db27.svg";